import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'directCall-transcription-modal',
    imports: [MatButtonModule, MatDialogModule, TranslateModule],
    templateUrl: './transcription-modal.component.html',
    styleUrls: ['./transcription-modal.component.scss']
})

export class TranscriptionModalComponent {

  constructor(public dialogRef: MatDialogRef<TranscriptionModalComponent>) { }

}
